export default {
      id: "notifications__lost_connection-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__lost_connection",
      toString: function () {
        return this.url;
      }
    }